import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
} from '@/view/components/ui/alert-dialog'
import { Button } from '@/view/components/ui/button'
import clsx from 'clsx'
import { AlertTriangle } from 'lucide-react'
import { useErrorWithdrawModalController } from './useErrorWithdrawModalController'

interface ErrorWithdrawModalProps {
  open: boolean
  onClose: () => void
  withdrawId: string | null
  errorMessage?: string | null
}

export const ErrorWithdrawModal: React.FC<ErrorWithdrawModalProps> = ({
  open,
  onClose,
  withdrawId,
  errorMessage,
}) => {
  const {
    selectedStatus,
    setSelectedStatus,
    approveWithdraw,
    refuseWithdraw,
    approving,
    refusing,
    canChangeStatus,
  } = useErrorWithdrawModalController()

  const handleConfirm = async () => {
    if (!withdrawId || !selectedStatus) return

    try {
      if (selectedStatus === 'PAGO') {
        await approveWithdraw(withdrawId)
      } else {
        await refuseWithdraw(withdrawId)
      }
      onClose()
    } catch (error) {
      console.error('Erro ao atualizar status manualmente:', error)
    }
  }

  return (
    <AlertDialog open={open}>
      <AlertDialogContent
        className="max-w-md"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-2">
          <div className="flex items-center justify-center rounded-full bg-primary/90 p-2">
            <AlertTriangle className="text-primary" size={16} />
          </div>
          <p className="text-md font-bold">Erro na atualização do pix</p>
        </div>

        <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
          <p className="font-bold">Houve um erro ao atualizar o saque:</p>
          <p className="text-sm">{errorMessage}</p>
        </div>

        {canChangeStatus && (
          <>
            <div className="h-0 border border-dashed" />
            <p className="text-sm font-medium">
              Para atualizar manualmente este saque, selecione uma das opções
              abaixo e clique em confirmar
            </p>

            <div className="mb-4 flex flex-col items-center justify-center gap-2 xs:flex-row">
              <Button
                onClick={() => setSelectedStatus('PAGO')}
                className={clsx(
                  'h-[74px] w-full sm:flex-1',
                  selectedStatus === 'PAGO'
                    ? 'bg-primary text-white01'
                    : 'border border-gray01 bg-white02 text-black hover:bg-gray-200',
                )}
              >
                PAGO
              </Button>
              <Button
                onClick={() => setSelectedStatus('NAO_PAGO')}
                className={clsx(
                  'h-[74px] w-full sm:flex-1',
                  selectedStatus === 'NAO_PAGO'
                    ? 'bg-primary text-white01'
                    : 'border border-gray01 bg-white02 text-black hover:bg-gray-200',
                )}
              >
                NÃO PAGO
              </Button>
            </div>
          </>
        )}
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose}>Fechar</AlertDialogCancel>
          {canChangeStatus && (
            <AlertDialogAction asChild>
              <Button
                className="bg-primary font-bold text-white01 hover:bg-primary hover:brightness-150"
                disabled={!selectedStatus || approving || refusing}
                onClick={handleConfirm}
              >
                Confirmar
              </Button>
            </AlertDialogAction>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
